
class OptionVariantSelector extends VariantSelector {
  constructor() {
    super();
    this.property = this.getAttribute('variant-option');
    this.value = false;
    this.displayValue = false;
    this.unavailableLabel = this.getAttribute('unavailable-label');
    this.formId = this.getAttribute('form-id');
    this.options = '';
    this.wrapper = this.querySelector(`.product-${this.property}-selector`);
    this.tooltip = this.querySelector(`.product-${this.property}-selector__tooltip`);
    this.label = this.querySelector(`.product-${this.property}-selector__label`);
  }

  render() {
    const options = window.variants.getVariantData(this.property);
    let markup = '';

    options.forEach((value) => {
      const selectorID = `selector-${this.property}-option-${value.dynamicHandle}`;

      markup += `<a class="product-form__input-wrapper button-text" href="${this.getAttribute('url-root')}/${value.dynamicHandle}">
        <input id="${selectorID}" type="radio" form="${this.formId}" name="${this.property}-option" value="${value.value}" class="p-small ${!value.enabled ? 'disabled' : ''}" selected="false" aria-disabled="${!value.enabled}" />
        <label for="${selectorID}" class="p-small">
          <span class="">${value.label}</span>
          <span class="visually-hidden sr-unavailable">${!value.enabled ? this.unavailableLabel : ''}</span>
          <svg><line x1="0" y1="98%" x2="100%" y2="2%"></line></svg>
        </label>
      </a>`
    });

    this.wrapper.insertAdjacentHTML('beforeend', markup);

    this.wrapper.classList.toggle('hidden', options.length === 0);

    this.wrapper.querySelectorAll('a.product-form__input-wrapper').forEach(element => {
      element.addEventListener('click', this.replaceHistoryEntryOnClick);
    });

    [...this.querySelectorAll('input[type="radio"]')].map(element => {
      element.addEventListener('change', this.onValueChanged.bind(this));
    })
  }

  setValue(value){
    super.setValue(value);
    const selected = this.querySelector(`[name="${this.property}-option"][value="${value}"`);
    selected.checked = true;
    this.updateLabel();
  }

  updateOptions(event){
    if (event.detail.property != this.property){
      const options = window.variants.getVariantData(this.property);
       
      for (var option in options){
        const input = this.querySelector(`input[value="${options[option].value}"]`);
        const label = input.nextElementSibling.querySelector('span.sr-unavailable');

        if (options[option].enabled){
          label.innerHTML = '';
          input.classList.remove('disabled');
        } else {
          label.innerHTML = this.unavailableLabel;
          input.classList.add('disabled');
        }
        input.setAttribute('aria-disabled', !options[option].enabled);
      }
      this.updateUrls();
    }
  }

  updateSelected(event) {
    if (event.detail.property == this.property){
      const selected = this.querySelector(`[name="${this.property}-option"][value="${event.detail.code}"]`);
      if (selected){
        selected.checked = true;
        this.updateLabel();
      }
    }
  }

  updateLabel() {
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.displayValue = this.querySelector(`label[for="${selected.id}"] span:first-child`).textContent;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`
    this.label.innerHTML = this.displayValue;
  }

  onValueChanged(event){
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);    
    this.setValue(selected.value);
    window.variants.setVariantOption(this.property, this.value);
  }

  updateUrls(){
    const baseUrl = `${this.getAttribute('url-root')}`;

    let params = new URLSearchParams(window.location.search);

    const stripParams = ['width', 'variant'];
    stripParams.forEach((value) => {
      if (params.get(value)){
        params.delete(value);
      }
    });

    const qs = params.toString();
    const options = window.variants.getVariantData(this.property);
    options.forEach((option) => {
      const element = this.querySelector(`[value="${option.value}"]`);
      if (!element.parentElement) return;
      const handle = option.enabled ? option.dynamicHandle : option.staticHandle;
      element.parentElement.setAttribute('href', `${baseUrl}/${handle}?${qs}&width=${option.value}`)
    });
  }
}

customElements.define('option-variant-selector', OptionVariantSelector);